import { AirportNode } from '../components/AirportNode';
import { HubNode } from '../components/HubNode';
import { HospitalNode } from '../components/HospitalNode';
import { TxCenterNode } from '../components/TxCenterNode';
import { ResourceNode } from '../components/ResourceNode';
import { AltAirportNode } from '../components/AltAirportNode';
import { AltHubNode } from '../components/AltHubNode';
import { AltHospitalNode } from '../components/AltHospitalNode';
import { AltTxCenterNode } from '../components/AltTxCenterNode';
import { StraightEdge } from '../components/StraightEdge';
import { StepEdge } from '../components/StepEdge';

// TODO: https://reactflow.dev/learn/troubleshooting/remove-attribution
export const proOptions = { hideAttribution: true };

export const mainNodeTypes = {
  Airport: AirportNode,
  Hub: HubNode,
  Hospital: HospitalNode,
  TxCenter: TxCenterNode,
  Custom: ResourceNode,
  HomeResidence: ResourceNode,
};

export const altNodeTypes = {
  Airport: AltAirportNode,
  Hub: AltHubNode,
  Hospital: AltHospitalNode,
  TxCenter: AltTxCenterNode,
  Custom: ResourceNode,
  HomeResidence: ResourceNode,
};

/** Full edge types for the main route schema (straight + step edges). */
export const mainEdgeTypes = {
  straightEdge: StraightEdge,
  stepEdge: StepEdge,
};

/** Simplified edge types for the unconnected legs schema (straight edges only). */
export const unconnectedEdgeTypes = {
  straightEdge: StraightEdge,
};

export const getNodeTypeVariants = (schemaType: 'main' | 'alt') =>
  schemaType === 'main' ? mainNodeTypes : altNodeTypes;
